// Unpublished Work © 2021-2025 Deere & Company.

import t from 'tcomb';
import {Routing} from './routing';
import {BusinessActivities} from './business-activities';
import {AppThemes, availableThemes} from '../../../literals/themes';
import {Features} from './features';

export const Configuration = t.struct({
    businessActivities: BusinessActivities,
    customerIdsOnFinancing: t.maybe(t.Array),
    currency: t.String,
    appUsage: t.maybe(t.String),
    features: Features,
    isLoading: t.Boolean,
    isStandalone: t.Boolean,
    locale: t.String,
    parentAppName: t.String,
    retailFinancingId: t.maybe(t.String),
    routing: Routing,
    showExamples: t.Boolean,
    theme: t.String,
    jdfFlow: t.Boolean,
    allowOrganizationSelection: t.Boolean
}, {
    defaultProps: {
        businessActivities: BusinessActivities({}),
        currency: 'USD',
        features: Features({}),
        isLoading: true,
        isStandalone: false,
        locale: '',
        parentAppName: '',
        routing: Routing({}),
        showExamples: true,
        theme: AppThemes.get(availableThemes.AGRICULTURE_TURF),
        jdfFlow: false,
        allowOrganizationSelection: false
    },
    name: 'Configuration',
    strict: true
});

Configuration.prototype.restrictAccess = function () {
    return this.isStandalone && !this.showExamples;
};
